import { Router } from 'aurelia-router';
import { LoginController } from '../../controllers/login-controller';
import { newInstance, autoinject } from 'aurelia-framework';

@autoinject

export class Index {

    constructor(public loginController: LoginController) {
    }


    configureRouter(config, router) {
        config.map([
            { name: 'forgot-password', route: 'forgot-password', moduleId: '/forgot-password' },
        ]);

        this.router = router;
    }
    header: string;
    router: Router;
}